import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { CommonResponse, DeviceCategoryAndDeptNameRequest } from "@gtpl/shared-models/masters";
import { TemperatureLogResponse, TemperatureResponse, DeptTemperaturesResponse, DayWiseDeptTempResponse, DeviceDetailsResponse } from "@gtpl/shared-models/warehouse-management";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Get, Param, Post, Req } from "@nestjs/common";
import { Cron } from "@nestjs/schedule";
import { DeviceCodeAndInfoRequest } from "./dto/deivce-id.request";
import { DeviceReq } from "./dto/device-req";
import { TempDeviceRequest } from "./dto/temp-device-req";
import { tempLogReq } from "./dto/temp-log-data.req";
import { TemperatureLogDto } from "./dto/temperature-log.dto";
import { DateDeptRequest, DayWiseTempRequest, DeptDateHourRequest, UidRequest } from "./request/date-dept.request";
import { UidResponse } from "./response/temperature-query.response";
import { TemperatureLogService } from "./temperature-log.service";

@Controller('temperature-log')
export class TemperatureLogController {
    constructor(
        private tempService: TemperatureLogService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }

    @Post('/createTemperatureLog')
    async createTemperatureLog(@Body() tempDto: TemperatureLogDto, @Req() request: Request): Promise<TemperatureLogResponse> {
        try {
            return await this.tempService.createTemperatureLog(tempDto, false, request);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(TemperatureLogResponse, error);
        }
    }

    @Post('/getTemperatures')
    async getTemperatures(@Body() tempReq: DateDeptRequest): Promise<TemperatureResponse> {
        try {
            return await this.tempService.getTemperatures(tempReq);
        } catch (error) {
            console.log(error, 'error-')
            return this.applicationExceptionHandler.returnException(TemperatureResponse, error);
        }
    }

    @Post('/getCurrentTemperature')
    async getCurrentTemperature(@Body() deptDateHourReq: DeptDateHourRequest): Promise<DeptTemperaturesResponse> {
        try {
            return await this.tempService.getCurrentTemperature(deptDateHourReq);
        } catch (error) {
            console.log(error, 'error-')
            return this.applicationExceptionHandler.returnException(DeptTemperaturesResponse, error);
        }
    }

    @Post('/getDayWiseTemeperaturesForDept')
    async getDayWiseTemeperaturesForDept(@Body() dayWiseReq: DayWiseTempRequest): Promise<DayWiseDeptTempResponse> {
        try {
            return await this.tempService.getDayWiseTemeperaturesForDept(dayWiseReq);
        } catch (error) {
            console.log(error, 'error-')
            return this.applicationExceptionHandler.returnException(DayWiseDeptTempResponse, error);
        }
    }

    @Post('/getTempDeviceDetails')
    async getTempDeviceDetails(@Body() req: UidRequest): Promise<DeviceDetailsResponse> {
        try {
            return await this.tempService.getTempDeviceDetails(req);
        } catch (error) {
            console.log(error, 'error-')
            return this.applicationExceptionHandler.returnException(DeviceDetailsResponse, error);
        }
    }

    @Post('/getCountOfTemperature')
    async getCountOfTemperature(): Promise<CommonResponse> {
        try {
            return await this.tempService.getCountOfTemperature();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllTempDetails')
    async getAllTempDetails(): Promise<CommonResponse> {
        try {
            return await this.tempService.getAllTempDetails();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    //cronjob
    @Cron('0 10 * * * *')
    @Post('/tempDataDump')
    async tempDataDump(@Body() tempDto: TemperatureLogDto,req:tempLogReq): Promise<CommonResponse> {
        try {
            return await this.tempService.tempDataDump(tempDto,req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    /**
     * gets the temperatures from the ext devices and persist them in the tables
     * @param temperatureDevicesInfo 
     * @returns 
     */
    @Post('/fetchTemperatureFromExtDeviceAndLogRecords')
    async fetchTemperatureFromExtDeviceAndLogRecords(@Body() temperatureDevicesInfo: DeviceCodeAndInfoRequest): Promise<GlobalResponseObject> {
        try {
            return await this.tempService.fetchTemperatureFromExtDeviceAndLogRecords([temperatureDevicesInfo]);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }

    /**
     * gets the temperature devices for the given unit and department and device category and downloads all the temperatures
     * @param req 
     */
    async getTemperatureDevicesAndLogTemperatures(@Body() req: DeviceCategoryAndDeptNameRequest): Promise<GlobalResponseObject> {
        try {
            return await this.tempService.getTemperatureDevicesAndLogTemperatures(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }

    // @Get('getAndInsertTempDataOld/:deviceMacId/:temperature/:logTime')
    // async getAndInsertTempDataOld(@Param() params: { deviceMacId: string, temperature: number, logTime: any}): Promise<GlobalResponseObject> {
    //     try {
    //         console.log(params.deviceMacId, params.temperature, params.logTime)
    //         const req = new DeviceReq(params.deviceMacId, params.temperature, params.logTime);
    //         return await this.tempService.getAndInsertTempData(req);
    //     } catch (error) {
    //         return await this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
    //     }
    // }

    @Post('getAndInsertTempData')
    async getAndInsertTempDat(@Body() req: TempDeviceRequest): Promise<GlobalResponseObject> {
        try {
            console.log(req,'Temperature device request')
            const {data} = req
            return await this.tempService.getAndInsertTempData(data);
        } catch (error) {
            return await this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }

}
